import Axios from "axios";
import moment from "moment";
import ipify from "react-native-ipify";
import {
  ipResolve,
  weatherIcon,
  weatherApi,
  weatherOneCallApi,
} from "../../endpoints";

const getWeather = async (setLoading, setWeather) => {
  try {
    setLoading(true);
    let resolve = await Axios.get(ipResolve);
    const { location } = resolve.data || {};
    const { city } = location || {};
    let res = await Axios.get(weatherApi(city));
    const { main, weather } = res.data || {};
    const { temp } = main || {};
    setWeather({
      ...weather[0],
      icon: weatherIcon(weather[0].icon),
      temp: Math.round(temp - 273.15).toString() + "°C",
      city,
      updatedAt: moment().format("hh:mm A"),
    });
    setLoading(false);
  } catch (e) {
    setLoading(true);
    let resolve = await Axios.get(ipResolve);
    const { location } = resolve.data || {};
    const { lat, lng, city } = location || {};
    let res = await Axios.get(weatherOneCallApi(lat, lng));
    const { current } = res.data || {};
    const { weather, temp } = current || {};
    setWeather({
      ...weather[0],
      icon: weatherIcon(weather[0].icon),
      temp: Math.round(temp - 273.15).toString() + "°C",
      city,
      updatedAt: moment().format("hh:mm A"),
    });
    setLoading(false);
  }
};

export default getWeather;
